export const CONTACT_SA_MODAL_ID = 'ContactSAModal'
export const CONTACT_SA_MODAL_CONTAINER_ID = 'ContactSAModalContainer'
export const OPEN_CONTACT_SA_MODAL = 'openContactShopApothekeModal'
export const PRODUCT_CONSULTATION_MESSAGE_FORM_CLASS =
  'o-ProductConsultationMessageForm'
